<template>
    <DefaultLayoutVue>
        <ListDeviceComp v-if="deviceId=='list'" />
        <DetailDeviceComp v-else :deviceId="deviceId" />
    </DefaultLayoutVue>
</template>

<script>
import DefaultLayoutVue from './layout/DefaultLayout.vue'
import ListDeviceComp from '@/components/widget/ListDeviceWidget.vue'
import DetailDeviceComp from '@/components/widget/DetailDeviceWidget.vue';

export default {
    components: {DefaultLayoutVue, ListDeviceComp, DetailDeviceComp} ,
    props: {
        deviceId: {
            default: "list"
        }
    }   
}
</script>